import { authActions } from "./features/authReducer";
import { cellListActions } from "./features/cellListReducer";
import { facilityListActions } from "./features/facilityListReducer";
import { userSelectionActions } from "./features/userSelectionReducer";

/** Shared logout side-effects; kept out of clientAPI to avoid a load-time import cycle (reducers → APIClient → hook → reducers). */
export function dispatchAppLogout(dispatch: any): void {
    dispatch(authActions.logout());
    dispatch(cellListActions.logout());
    dispatch(facilityListActions.logout());
    dispatch(userSelectionActions.logout());
}
